import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dropFirstTimeFlag } from './actions';
import { hasFirstTimeFlag } from './selectors';
export function useFirstTimeFlag(flag) {
    const hasFlag = useSelector((state)=>hasFirstTimeFlag(state, flag));
    const dispatch = useDispatch();
    const dropFlag = useCallback(({ redirectTo } = {})=>dispatch(dropFirstTimeFlag({
            flag,
            redirectTo
        })), [
        flag,
        dispatch
    ]);
    return {
        hasFlag,
        dropFlag
    };
}

//# sourceMappingURL=hooks.js.map